import { render } from "./Mikomi_Others.vue?vue&type=template&id=1b956f3e"
import script from "./Mikomi_Others.vue?vue&type=script&lang=js"
export * from "./Mikomi_Others.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__